const api = {
	listMallUserGroups: '/userGroup/listMallUserGroups', // 商城岗位列表
	addMallUserGroup: '/userGroup/addMallUserGroup', // 新增商城岗位
	editMallUserGroup: '/userGroup/editMallUserGroup', // 编辑商城岗位
	deleteMallGroup: '/userGroup/deleteMallUserGroup', // 删除商城岗位
	getMallUserGroup: '/userGroup/getMallUserGroup', // 获取商城岗位详情
	listMallNormalPrividges: '/userGroup/listMallNormalPrividges' // 获取商城所有的权限
};

const routes = {
	'/mall-job': '岗位管理',
	'/mall-job/detail': '岗位详情',
	'/mall-job/edit': '编辑岗位',
	'/mall-job/add': '新增岗位'
};

export { api, routes };
